import { createContext, useContext, useState, useCallback, useMemo, useEffect } from "react";
import { translations } from "@/data/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        if (typeof window === "undefined") return "it";
        const stored = window.localStorage.getItem("fw_lang");
        if (stored === "it" || stored === "en") return stored;
        const browser = (navigator.language || "it").slice(0, 2).toLowerCase();
        return browser === "en" ? "en" : "it";
    });

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.localStorage.setItem("fw_lang", lang);
            document.documentElement.lang = lang;
        }
    }, [lang]);

    const toggleLang = useCallback(() => {
        setLang((prev) => (prev === "it" ? "en" : "it"));
    }, []);

    const value = useMemo(
        () => ({
            lang,
            setLang,
            toggleLang,
            t: translations[lang],
        }),
        [lang, toggleLang]
    );

    return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
    return ctx;
};
